import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, IconButtonProps } from "@mui/material";

export const StyledDeleteButton = styled((props: IconButtonProps) => (
  <IconButton {...props}>
    <DeleteIcon />
  </IconButton>
))(({ theme }) => ({
  fontSize: 16,
  marginTop: -0.5,
  height: 18,
  "&:focus": {
    outline: 0,
  },
  "&.MuiIconButton-root": {
    padding: 0,
    paddingLeft: "5px",
    color: `${theme.palette.redAlert.main} !important`,
    cursor: "pointer",
  },
}));
